export default __webpack_public_path__ + "static/media/whyDoesPatti.593f2b04.wav";